// extracted by mini-css-extract-plugin
export default {"button":"button","primary":"primary","secondary":"secondary","disabled":"disabled","danger":"danger"};